export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11495.5e3928a6.jpg";